export const getLayout = ({
  showlegend,
  xaxis,
  yaxis,
  margin,
  legend,
  font,
  barmode,
  bargap,
  bargroupgap,
}: Partial<Plotly.Layout>) => ({
  autosize: true,
  font: { size: font?.size || 12, family: font?.family || 'Inter' },
  margin: {
    l: margin?.l ?? 15,
    r: margin?.r ?? 15,
    b: margin?.b ?? 90, // increased to make space for legend
    t: margin?.t ?? 10,
  },
  xaxis: {
    automargin: true,
    type: xaxis?.type || 'category',
    showgrid: false,
    zeroline: false,
    tickvals: xaxis?.tickvals || undefined,
    ticktext: xaxis?.ticktext || undefined,
    title: {
      text: xaxis?.title?.text || '',
      standoff: 10, // space between title and ticks
    },
  },
  yaxis: {
    title: {
      text: yaxis?.title?.text || '',
      standoff: 20, // increased standoff for more space between title and ticks
    },
    automargin: true,
    tickformat: ',d',
    rangemode: 'tozero',
    zeroline: true,
    range: yaxis?.range || undefined,
  },
  legend: {
    orientation: legend?.orientation || 'h',
    x: legend?.x || 0.5,
    y: legend?.y || -0.15,
    xanchor: legend?.xanchor || 'center',
    yanchor: legend?.yanchor || 'right',
  },
  barmode: barmode ?? 'stack',
  bargap: bargap ?? undefined,
  bargroupgap: bargroupgap ?? undefined,
  showlegend: showlegend ?? true,
});
